'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');
var overlay_module = require('./overlay.module.scss.js');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Overlay = function Overlay(_ref) {
  var clickFn = _ref.clickFn,
    disabled = _ref.disabled,
    className = _ref.className;
  return /*#__PURE__*/jsxRuntime.jsx("button", {
    "aria-label": "overlay",
    type: "button",
    className: "".concat(overlay_module.default['overlay'], " ").concat(className),
    id: "catoverlay",
    disabled: disabled,
    onClick: clickFn,
    tabIndex: -1
  });
};
Overlay.propTypes = {
  className: PropTypes__default.default.string,
  clickFn: PropTypes__default.default.func,
  disabled: PropTypes__default.default.bool
};
Overlay.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Overlay",
  "props": {
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "clickFn": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};
var Overlay$1 = Overlay;

exports.default = Overlay$1;
//# sourceMappingURL=Overlay.js.map
